import { render, staticRenderFns } from "./BrandWall.vue?vue&type=template&id=28544c82&scoped=true&"
import script from "./BrandWall.vue?vue&type=script&lang=js&"
export * from "./BrandWall.vue?vue&type=script&lang=js&"
import style0 from "./BrandWall.vue?vue&type=style&index=0&id=28544c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28544c82",
  null
  
)

export default component.exports